module.exports = __webpack_public_path__ + "static/corn-251b2422dbb8f517f71af244eb318a16.png";